export default __webpack_public_path__ + "static/0175-c4d0aa87f6d862d074aa983b42e491ac.png";